import { PresetId } from '@account/account-portal/config'

import AdiClubLogo from '../../assets/icons/adi-club-logo.svg?inline'
import adiclubBlueDesktop from '../../assets/icons/adiclub-blue-desktop.svg?inline'
import adiclubBlueMobile from '../../assets/icons/adiclub-blue-mobile.svg?inline'
import AdidasRunningLogo from '../../assets/icons/adidas-running.svg?inline'
import AdidasLogo from '../../assets/icons/adidas.svg?inline'
import ConfirmedAppLogo from '../../assets/icons/confirmed-icon.svg?inline'

interface BannerImage {
  mobile: string
  desktop: string
}

export const DefaultBannerImage: BannerImage = {
  mobile: adiclubBlueMobile,
  desktop: adiclubBlueDesktop,
}

export const BannerImageMap: Partial<Record<PresetId, BannerImage>> = {
  ['confirmed-app']: {
    mobile: ConfirmedAppLogo,
    desktop: ConfirmedAppLogo,
  },
  ['adidas-app']: {
    mobile: AdidasLogo,
    desktop: AdidasLogo,
  },
  ['subscription-inline']: {
    mobile: '',
    desktop: '',
  },
  ['adidas-running']: {
    mobile: AdidasRunningLogo,
    desktop: AdidasRunningLogo,
  },
  ['checkout-inline']: {
    mobile: '',
    desktop: '',
  },
}
